import { SortDirection } from "generated/graphql";

export const REFETCH_QUERY_FIRST_VARIABLE = 10;
export const REFETCH_QUERY_DEFAULT_PAGE = 1;
export const REFETCH_QUERY_DEFAULT_SEARCH = null;
export const REFETCH_QUERY_DEFAULT_SORT = SortDirection.ASC;
